import NotificationMixin from 'Support/mixins/notification-mixin';
import RouterMixin from 'Support/mixins/router-mixin';

export default {
  mixins: [NotificationMixin, RouterMixin],
  data: () => ({
    showSuccessToastMessage: true,
    formsRef: 'form',
    formValid: false,
    loadEntityOnCreate: true,
    loadingForm: false,
  }),
  created() {
    if (this.loadEntityOnCreate && this.entityId) {
      this.loadEntityForEdit();
    }
  },
  computed: {
    successToasMessageCreate() {
      return this.$t('support.components.crudForm.novoRegistro');
    },
    entityId() {
      return this.$route.params.id;
    },
    loading() {
      return this.loadingForm;
    },
  },
  methods: {
    loadEntityForEdit() {
      this.requestClass
        .get(this.entityId)
        .then(({ data }) => {
          if (Array.isArray(data)) {
            this.setEntityData(data[0]);
          } else {
            this.setEntityData(data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setEntityData(data) {
      this.payload = data;
    },
    validateForm() {
      return this.$refs[this.formsRef].validate();
    },
    save() {
      if (!this.validateForm()) {
        this.showErrorToast({
          text: 'Existem erros no formulário.',
        });
        return;
      }
      if (this.entityId) {
        this.update();
      } else {
        this.create();
      }
    },
    getCreatePayload() {
      return this.payload;
    },
    create() {
      this.loadingForm = true;
      this.requestClass
        .save(this.getCreatePayload())
        .then(() => {
          if (this.showSuccessToastMessage) {
            this.showSuccessToast({
              text: this.successToasMessageCreate,
            });
          }
          this.afterSave();
        })
        .catch(({ response }) => {
          this.showMessageError(response);
        })
        .finally(() => {
          this.loadingForm = false;
        });
    },
    afterSave() {
      if (this.navigateToPageAfterSave) {
        this.navigateTo(this.navigateToPageAfterSave);
      }
    },
    getEditPayload() {
      return this.payload;
    },
    showMessageError(response) {
      this.showErrorToast({
        text: response.data.message || 'Falha ao se comunicar com o servidor.',
      });
    },
    update() {
      this.loadingForm = true;
      this.requestClass
        .edit(this.entityId, this.getEditPayload())
        .then(() => {
          this.showSuccessToast({
            text: 'Registro atualizado.',
          });

          this.afterSave();
        })
        .catch(({ response }) => {
          this.showMessageError(response);
        })
        .finally(() => {
          this.loadingForm = false;
        });
    },
  },
};
